import React, { useEffect, useState } from "react";
import { Box, Row, ColumnTow } from "../FooterStyles";

function UpdatePasswordView({ saveNewPassword }) {
  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const [actualPassword, setActualPassword] = useState(null);
  const [newpassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <Box
      style={{
        backgroundColor: "#fff",
        padding: size.width <= 428 ? 0 : " 45px 0px",
      }}
    >
      <Row>
        <ColumnTow>
          <div className="lieu">
            <input
              type="password"
              key="passwordactual"
              id="passwordactual"
              value={actualPassword}
              onChange={(e) => setActualPassword(e.currentTarget.value)}
              className="oraleway-normal-silver-14px-nopadding"
              name="passwordactual01"
              placeholder="Mon mot de passe actuel"
              style={{ width: 264, fontSize: "16px" }}
            />
            <img
              className="ligne-2"
              style={{ width: 264 }}
              src={process.env.PUBLIC_URL + "/ligne-2-2.png"}
              alt=""
            />
          </div>
        </ColumnTow>
      </Row>
      <Row>
        <ColumnTow>
          <div className="lieu" style={{ marginTop: 20 }}>
            <input
              type="password"
              value={newpassword}
              onChange={(e) => setNewPassword(e.currentTarget.value)}
              className="oraleway-normal-silver-14px-nopadding"
              name="newpassword01"
              placeholder="Nouveau mot de passe"
              style={{ width: 264, fontSize: "16px" }}
            />
            <img
              className="ligne-2"
              style={{ width: 264 }}
              src={process.env.PUBLIC_URL + "/ligne-2-2.png"}
              alt=""
            />
          </div>
        </ColumnTow>
        <ColumnTow>
          <div className="lieu" style={{ marginTop: 20 }}>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.currentTarget.value)}
              className="oraleway-normal-silver-14px-nopadding"
              name="passwordactual01"
              placeholder="Confirmer votre mot de passe"
              style={{ width: 264, fontSize: "16px" }}
            />
            <img
              className="ligne-2"
              style={{ width: 264 }}
              src={process.env.PUBLIC_URL + "/ligne-2-2.png"}
              alt=""
            />
          </div>
        </ColumnTow>
      </Row>
      <Row>
        <ColumnTow>
          <button
            class="bouton-plein border-1px-dove-gray"
            style={{
              height: 55,
              marginTop: "20px",
              background: loading && "white",
              border: loading && "white",
            }}
            disabled={loading}
            onClick={() => {
              if (actualPassword && newpassword == confirmPassword)
                setLoading(true);
              saveNewPassword(
                actualPassword,
                newpassword,
                confirmPassword,
                function () {
                  setActualPassword("");
                  setNewPassword("");
                  setConfirmPassword("");
                  setLoading(false);
                }
              );
            }}
          >
            <div
              class="prendre-rdv raleway-semi-bold-white-18px"
              style={{
                color: loading && "black",
              }}
            >
              {loading ? "Chargement ..." : "Valider"}
            </div>
          </button>
        </ColumnTow>
        <div id="recaptcha-container" />
      </Row>
    </Box>
  );
}

export default UpdatePasswordView;
